import {
  Wrench,
  ChartNoAxesCombined,
  ShieldCheck,
  MessagesSquare,
  MapPin,
  Building2,
} from "lucide-react";
import building835 from "../assets/building835.jpg";
import building557 from "../assets/building557.jpg";
import buildingOneCQ from "../assets/buildingOneCQ.jpg";
import buildingVictoriaBurke from "../assets/buildingVictoriaBurke.jpg";
import buildingPentridge from "../assets/buildingPentridge.jpg";

export const navigation = [
  { path: "/services", label: "Services" },
  { path: "/about", label: "Our approach" },
  { path: "/portfolio", label: "Communities" },
];
export const contact = {
  email: "admin@ownersfirst.com.au",
  phone: "03 9988 7700",
  telephone: "tel:0399887700",
  emergency: "1300 556 550",
  emergencyTelephone: "tel:1300556550",
};
export const services = [
  {
    id: "maintenance",
    title: "Maintenance & property care",
    icon: Wrench,
    summary: "The right people. The right work. Properly followed through.",
    description:
      "We coordinate repairs and maintenance from the first quote to the completed job. Regular property visits help us understand what needs attention, so work orders are informed by the building itself.",
    details: [
      "Quotes, work orders and contractor coordination",
      "Trades checked for the appropriate licences and insurance",
      "Follow-up on the quality and completion of work",
    ],
  },
  {
    id: "financials",
    title: "Financial management",
    icon: ChartNoAxesCombined,
    summary: "Clear records and a practical plan for your property.",
    description:
      "Your owners corporation should know where its money is going. We take care of day-to-day accounting, financial reporting and records, keeping the information accessible to owners and committees.",
    details: [
      "Budgets, financial statements and accounting",
      "Levy administration and debt collection",
      "Clear records to support committee decisions",
    ],
  },
  {
    id: "insurance",
    title: "Insurance & claims",
    icon: ShieldCheck,
    summary: "Support through the details, from annual cover to a claim.",
    description:
      "We help arrange property valuations, obtain insurance quotes and coordinate the claims process. Annual reviews help your owners corporation consider its cover and costs.",
    details: [
      "Insurance valuations and annual quotations",
      "Claims administration and communication",
      "Coordination with specialist insurance brokers",
    ],
  },
  {
    id: "meetings",
    title: "Meetings & communication",
    icon: MessagesSquare,
    summary: "Straight answers. Shared decisions. Everyone kept in the loop.",
    description:
      "We organise annual general meetings and work with committees between meetings. We look after the records, correspondence and follow-through so decisions turn into action.",
    details: [
      "Annual general and committee meeting coordination",
      "Minutes, records and owners corporation documentation",
      "Plain-language updates and accessible information",
    ],
  },
  {
    id: "visits",
    title: "A manager who shows up",
    icon: MapPin,
    summary: "On site at least four times a year. Involved all year round.",
    description:
      "We believe a manager should know the property they manage. Our service charter includes at least four site visits each year, at no additional charge, with owners and committees involved wherever possible.",
    details: [
      "Quarterly visits as a minimum",
      "A first-hand understanding of the building",
      "Practical conversations with owners and committees",
    ],
  },
  {
    id: "development",
    title: "Support for developers",
    icon: Building2,
    summary: "Get the foundations of your owners corporation right.",
    description:
      "Our developer program brings owners corporation advice into the planning and delivery of a project. A dedicated team works through the immediate requirements with the future community in mind.",
    details: [
      "Owners corporation consultancy",
      "A dedicated point of contact for developers",
      "Support that considers the long-term needs of owners",
    ],
  },
];
export const properties = [
  {
    id: "835-high",
    name: "835 High",
    area: "Armadale",
    image: building835,
    description:
      "A boutique collection of 26 spacious apartments, combining carefully considered materials with generous spaces for everyday living.",
  },
  {
    id: "one-coburg-quarter",
    name: "One Coburg Quarter",
    area: "Coburg",
    image: buildingOneCQ,
    description:
      "Curved balconies, planted terraces and a connection to Coburg’s character bring a distinctive sense of place to this residential community.",
  },
  {
    id: "victoria-burke",
    name: "Victoria & Burke",
    area: "Camberwell",
    image: buildingVictoriaBurke,
    description:
      "A garden setting and contemporary interpretation of traditional architecture, reflecting the character of its Camberwell surroundings.",
  },
  {
    id: "metro-park-west",
    name: "Metro Park West",
    area: "Melbourne",
    image: building557,
    description:
      "A contemporary city building bringing together 195 apartments and ground-floor retail, with the day-to-day needs of a busy community.",
  },
  {
    id: "pentridge",
    name: "Pentridge",
    area: "Coburg",
    image: buildingPentridge,
    description:
      "A landmark heritage precinct evolving into a neighbourhood of residential and commercial spaces, balancing its history with a new chapter.",
  },
];
export const questions = [
  {
    question: "How do we change our owners corporation manager?",
    answer:
      "Start with a conversation about your property and your current arrangements. We can explain the next steps and help your committee understand the transition.",
  },
  {
    question: "Will our manager visit our property?",
    answer:
      "Yes. Our service charter commits to at least four property visits each year, at no additional charge. Knowing your building is part of how we look after it.",
  },
  {
    question: "What kinds of properties do you manage?",
    answer:
      "Our portfolio includes boutique apartments, larger residential buildings and mixed-use communities across Melbourne. We also work with developers on new projects.",
  },
];
